import type { UrlObject } from 'node:url'

// NOTE: в старых постах категория могла не указываться
export function getPostCategory(label: string) {
    return label === '' ? 'post' : label
}

type GetPostLinkArgs = {
    label: string
    slug: string
}

export function getPostLink({ slug, label }: GetPostLinkArgs): UrlObject {
    const pathname = `/${getPostCategory(label)}/${slug}`

    return { pathname }
}
